import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  // Only used for drop-in UI
  async generateClientToken() {
    try {
      const response = await axios.get('braintree/token');
      return response.data;
    } catch (err) {
      return null;
    }
  },

  // Returns 0 if they have already paid or if the course is free
  async getClassPurchaseData(_, { classId, couponCode }) {
    let route = `braintree/price/${classId}`;
    if (couponCode) {
      route = `${route}?couponCode=${encodeURIComponent(couponCode)}`;
    }

    const response = await axios.get(route);
    return response.data;
  },

  purchaseCourse(_, { classId, paymentNonce, couponCode }) {
    return axios.post(`braintree/class/${classId}`, { paymentNonce, couponCode });
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/braintree/braintree.js